import {Dialog, DialogTitle, DialogContent, DialogActions, Radio, RadioGroup, FormControlLabel, FormControl, Button, Typography} from "@mui/material";
import React, {useState} from "react";
import {Language} from "../model/Language";
import {useTranslation} from "react-i18next";

export function useTestmailDialog(): [JSX.Element, (title: string, content: string, onConfirmation: (language: Language) => void) => void] {

    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [selectedLanguage, setSelectedLanguage] = useState<Language>(Language.DE);
    const [onConfirm, setOnConfirm] = useState<(language: Language) => void>(() => () => {});
    const {t} = useTranslation();

    const handleCancel = () => {
        setOpen(false);
    };

    const handleProceed = () => {
        onConfirm(selectedLanguage);
        setOpen(false);
    };

    const openDialog = (dialogTitle: string, dialogContent: string, onConfirmation: (language: Language) => void) => {
        setTitle(dialogTitle);
        setContent(dialogContent);
        setOnConfirm(() => onConfirmation);
        setOpen(true);
    };

    const dialog = (
        <Dialog open={open} onClose={handleCancel}>
            <DialogTitle>{title || t('templateTable.selectLanguage')}</DialogTitle>
            <DialogContent>
                <Typography sx={{ mb: 2 }}>
                    {content}
                </Typography>
                <FormControl>
                    <RadioGroup
                        value={selectedLanguage}
                        onChange={(e) => setSelectedLanguage(e.target.value as Language)}
                    >
                        <FormControlLabel value={Language.DE} control={<Radio />} label="Deutsch" />
                        <FormControlLabel value={Language.EN} control={<Radio />} label="English" />
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>{t('common.cancel')}</Button>
                <Button onClick={handleProceed} variant="contained">{t('common.confirm')}</Button>
            </DialogActions>
        </Dialog>
    );

    return [dialog, openDialog];
}

